import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Snackbar,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import DynamicFormTable from "../Candidates/DynamicFormTable";

const apiUrl = process.env.REACT_APP_API_URL;




const ApplicationsList = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [adminCompany, setAdminCompany] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [scale, setScale] = useState(1);
  const [viewType, setViewType] = useState("card");
  const userId = getUserIdFromAccessToken();

  // Add scaling effect
  useEffect(() => {
    const handleResize = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const contentHeight = 800; // Approximate height of your content
      const contentWidth = 1200; // Approximate width of your content
      
      // Calculate scale based on both height and width
      const heightScale = (windowHeight * 0.95) / contentHeight; // 95% of window height
      const widthScale = (windowWidth * 0.95) / contentWidth; // 95% of window width
      
      // Use the smaller scale to ensure content fits both dimensions
      let newScale = Math.min(heightScale, widthScale, 1);
      
      // Add minimum scale limit based on screen width
      if (windowWidth <= 1920) { // For 1080p and similar resolutions
        newScale = Math.max(newScale, 0.8); // Minimum 80% scale
      } else if (windowWidth <= 2560) { // For 1440p
        newScale = Math.max(newScale, 0.85); // Minimum 85% scale
      } else {
        newScale = Math.max(newScale, 0.9); // Minimum 90% scale for larger screens
      }
      
      setScale(newScale);
    };

    handleResize(); // Initial scale
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  function getUserIdFromAccessToken() {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token found in local storage");
      return null;
    }
    try {
      const decodedToken = parseJwt(accessToken);
      return decodedToken.user_id;
    } catch (error) {
      console.error("Failed to decode access token", error);
      return null;
    }
  }

  function parseJwt(token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  }
  const fetchAdminCompany = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${apiUrl}authentication/recruiter/${userId}/admin/`
      );
      setAdminCompany(response.data.admin_company);
      setError(null);
    } catch (err) {
      console.error("Error fetching admin company:", err);
      setError(err.response?.data?.message || "Failed to load admin company");
      showSnackbar("Failed to load admin company", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAdminCompany();
  }, []);

  const showSnackbar = (message, severity = "info") => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }

  return (
    <Box sx={{ 
      transform: `scale(${scale})`,
      transformOrigin: 'top left',
      width: `${100 / scale}%`,
      height: `${100 / scale}%`,
      transition: 'transform 0.3s ease-in-out'
    }}>
      {error ? (
        <Typography color="error">{error}</Typography>
      ) : (
        <DynamicFormTable
          data={[]}
          viewType={viewType}
          setViewType={setViewType}
          showShareButton={true}
          shareCompanyName={adminCompany}
          disableScaling={true}
        />
      )}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        sx={{
          "& .MuiSnackbarContent-root": {
            backgroundColor: "rgba(255, 255, 255, 0)",
            color: "black",
            borderRadius: "50px",
            backdropFilter: "blur(3px)",
            boxShadow: "0 4px 30px rgba(0, 0, 0, 0.5)",
          },
        }}
        message={snackbar.message}
      ></Snackbar>
    </Box>
  );
};

export default ApplicationsList;
